<script>
import moment from "moment";
import xorBy from "lodash/xorBy";
import cloneDeep from "lodash/cloneDeep";
export default {
  data() {
    const regionId = this.$route.params.regionId;
    return {
      regionId,
      regionDetial: {},
      tableData: [],
      editRegion: false,
      addNewProvince: false,
      removeProvince: false,
      buttonArray: [
        {
          text: "编辑",
          key: "edit"
        }
      ],
      formInputArray: [
        {
          label: "大区名称",
          keyName: "regionName",
          type: "text"
        },
        {
          label: "大区经理",
          keyName: "managerId",
          type: "select",
          children: []
        }
      ],
      formInputAddArray: [
        {
          label: "大区名称",
          keyName: "regionName",
          type: "text",
          isDisable: true
        },
        {
          label: "大区经理",
          keyName: "regionManager",
          type: "text",
          isDisable: true
        },
        {
          label: "管理范围",
          keyName: "range",
          type: "select",
          children: []
        }
      ],
      tableButtonArray: [
        {
          text: "撤销管理",
          key: "unbind"
        }
      ],
      defaultValue: {}
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      let data = await this.$http.AdminRegionById(this.regionId);
      if (data) {
        let regionDetial = {
          regionId: data.region.id,
          regionManager: data.region.manager ? data.region.manager.name : "",
          regionName: data.region.regionName,
          updatedAt: data.region.updatedAt
            ? moment(data.region.updatedAt).format("YYYY-MM-DD")
            : "--",
          managerId: data.region.manager ? data.region.manager.id : ""
        };
        this.regionDetial = regionDetial;
        this.tableData = data.provinces;
        console.log("---", data);
      }
    },
    async onEditRegion() {
      let data = await this.$http.getManagerList();
      if (data && data.content) {
        let children = [];
        data.content.forEach(o => {
          children.push({
            keyName: o.content.id,
            label: o.content.name
          });
        });
        this.formInputArray[1].children = children;
      }
      this.editRegion = true;
    },
    async onUpdateRegion(formdata, type, row) {
      if (type === "deleteRegion") {
        const updateData = {
          regionId: row.regionId
        };
        let data = await this.$http.AdminManagementRegion(updateData, "remove");
        if (data === "success") {
          this.loadData();
        }
      }
      this.defaultValue = {};
    },
    async onSubmit(from) {
      const updateData = {
        regionName: from.regionName,
        managerId: from.managerId,
        regionId: this.regionId
      };
      let data = await this.$http.AdminManagementRegion(updateData, "update");
      if (data === "success") {
        this.loadData();
      }
    },
    async ononClickAddProvince() {
      const ProvinceList = await this.$http.getProvinceList("superAdminRegion");
      const xorList = xorBy(ProvinceList, this.tableData, "id");
      if (xorList.length > 0) {
        let tempChildren = [];
        xorList.forEach(o =>
          tempChildren.push({
            label: o.name,
            keyName: o.id
          })
        );
        let tempFormInputArray = this.formInputAddArray;
        tempFormInputArray[2].children = tempChildren;
        this.formInputAddArray = tempFormInputArray;
        this.addNewProvince = true;
        console.log("xorList", tempChildren);
      } else {
        alert("没有可以添加的省份了！");
      }
    },
    async onUpdateRegionProvince(formdata, type, row) {
      console.log("-->>>>>", formdata, type, row);
      if (type === "addProvince") {
        const updateData = {
          regionId: this.regionId,
          districtId: formdata.range
        };
        const result = await this.$http.AdminEditRegionProvince(
          updateData,
          "addProvince"
        );
        if (result === "success") {
          this.loadData();
        }
      } else if (type === "removeProvince") {
        const updateData = {
          regionId: this.regionId,
          districtId: row.id
        };
        const result = await this.$http.AdminEditRegionProvince(
          updateData,
          "removeProvince"
        );
        if (result === "success") {
          this.loadData();
        }
      }
      this.defaultValue = {};
    },
    onOperationClick(row, key) {
      this.defaultValue = row;
      this.removeProvince = true;
    },
    onClickCancel(key) {
      this.defaultValue = {};
      this.removeProvince = false;
    }
  }
};
</script>
<template>
  <div class="rangeManagementDetialIndex">
    <el-card class="box-card cardStyle" shadow="never">
      <div slot="header" class="clearfix">
        <span class="cardTitleText">基本信息</span>
        <DialogForm
          v-if="editRegion"
          formTitle="编辑大区信息"
          :formInputArray="formInputArray"
          @close="editRegion = false"
          @submitForm="onSubmit"
          :defaultValue="regionDetial"
        />
        <textButtonGroup
          class="editButton"
          :buttonArray="buttonArray"
          @onOperationClick="onEditRegion"
        />
      </div>
      <div class="text item">
        <el-row :gutter="24">
          <el-col :span="8">
            <div class="grid-content bg-purple">大区名称: {{regionDetial.regionName}}</div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">大区经理: {{regionDetial.regionManager}}</div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">更新时间: {{regionDetial.updatedAt}}</div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <el-card class="box-card cardStyle" shadow="never">
      <DialogForm
        v-if="addNewProvince"
        formTitle="添加管理范围"
        :formInputArray="formInputAddArray"
        @close="addNewProvince = false"
        :defaultValue="regionDetial"
        @submitForm="onUpdateRegionProvince"
        keyOperation="addProvince"
      />
      <DialogForm
        v-if="removeProvince"
        formTitle="确认撤销管理"
        @close="removeProvince = false"
        :defaultValue="defaultValue"
        @submitForm="onUpdateRegionProvince"
        keyOperation="removeProvince"
        confirmButton="确认"
      />
      <elementButton class="addButton" @click="ononClickAddProvince">添加管理范围</elementButton>
      <el-table
        :data="tableData"
        class="accountTable"
        :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
        :cell-style="{'padding-left': '5px'}"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="name" align="left" label="省份"></el-table-column>
        <el-table-column prop="operation" align="left" label="操作" width="180">
          <template slot-scope="scope">
            <textButtonGroup
              :buttonArray="tableButtonArray"
              :rowData="scope.row"
              @onOperationClick="onOperationClick"
            />
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.rangeManagementDetialIndex {
  background-color: #f5f6f7;
  .cardStyle {
    margin: 15px 0;
    border: 0px;
  }

  .addButton {
    width: 120px;
    height: 38px;
    // margin-top: 13px;
    border-radius: 3px;
    margin: 10px 0;
  }
  .cardTitleText {
    font-size: 16px;
    font-weight: bold;
  }
  .accountTable {
    margin: 20px 0;
    border: 1px;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    th > .cell {
      font-weight: bold;
    }
  }

  .el-row {
    display: flex;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .el-col {
    align-self: center;
    border-radius: 4px;
  }

  .grid-content {
    padding: 15px 0px;
    border-radius: 4px;
  }

  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  .editButton {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rangeManagement/rangeManagementDetail.vue